import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { getPlannedClinic } from '../../utils/helpers';
import FacilityAddress from '../FacilityAddress';

const FacilityConfirmation = ({ NavButtons, data, goForward, goToPath }) => {
  const {
    userSelected: selectedFacility,
    caregiverSupport: selectedCaregiverSupportFacility,
  } = getPlannedClinic(data);

  const isReviewPage = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('review') === 'true';
  }, []);

  const onGoForward = useCallback(
    () => (isReviewPage ? goToPath('/review-and-submit') : goForward(data)),
    [data, goForward, goToPath, isReviewPage],
  );

  const PageTitle = titleUI('Caregiver support location')['ui:title'];

  return (
    <>
      {PageTitle}
      <p>
        This is the location we’ve assigned to support the caregiver in the
        application process:
      </p>
      <FacilityAddress facility={selectedCaregiverSupportFacility} />
      <p>
        This VA health facility has a Caregiver Support Team coordinator. And
        this facility is closest to where the Veteran receives or plans to
        receive care.
      </p>
      <h2 className="vads-u-font-size--h3">The Veteran’s VA health facility</h2>
      <p>
        The Veteran will still receive their healthcare at the facility you
        selected:
      </p>
      <FacilityAddress facility={selectedFacility} />
      <NavButtons goForward={onGoForward} />
    </>
  );
};

FacilityConfirmation.propTypes = {
  NavButtons: PropTypes.func,
  data: PropTypes.object,
  goForward: PropTypes.func,
  goToPath: PropTypes.func,
};

export default FacilityConfirmation;
